export enum ERunaiVerifyButtonStatus {
  None = "none",
  Verifying = "verifying",
  Verified = "verified",
  Failed = "failed",
}
